import React, { Component } from 'react';
import { connect }                       from 'react-redux'
import { addFavourite, removeFavourite } from './../actions/UserAction';
import FavouriteIcon                     from '../components/FavouriteIcon';

class FavouriteContainer extends Component
{
    render = () =>
    {
        if (this.props.place.isSet)
        {
            return <FavouriteIcon { ...this.props } />
        }

        return null;
    }
}

const mapStateToProps = (state) => {
    return {
        theme: state.assets.items.theme.filters,
        place: state.place,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        favourite: (placeId) => {
            dispatch(addFavourite(placeId));
        },
        unFavourite: (placeId) => {
            dispatch(removeFavourite(placeId));
        }
    }
};

FavouriteContainer = connect(mapStateToProps, mapDispatchToProps)(FavouriteContainer);

export default FavouriteContainer;


// WEBPACK FOOTER //
// ./src/containers/FavouriteContainer.js